import { validateCpf } from '@/helpers/cpf.validator';
import {
  formatAlphanumericCNPJ,
  normalizeAlphanumericCNPJ,
  validateAlphanumericCNPJ,
} from '@/helpers/cnpj-alphanumeric.validator';

export type TipoPessoa = 'FISICA' | 'JURIDICA';

const CPF_LENGTH = 11;

const cleanValue = (value = ''): string => String(value || '').toUpperCase().replace(/[^0-9A-Z]/g, '');

export const detectTipoPessoa = (value = ''): TipoPessoa | null => {
  const cleaned = cleanValue(value);

  if (!cleaned) return null;

  const hasLetters = /[A-Z]/.test(cleaned);

  if (hasLetters || cleaned.length > CPF_LENGTH) {
    return 'JURIDICA';
  }

  return 'FISICA';
};

const applyCpfMask = (digits: string): string => {
  const part1 = digits.slice(0, 3);
  const part2 = digits.slice(3, 6);
  const part3 = digits.slice(6, 9);
  const part4 = digits.slice(9, 11);

  let formatted = part1;
  if (part2) formatted += `.${part2}`;
  if (part3) formatted += `.${part3}`;
  if (part4) formatted += `-${part4}`;

  return formatted;
};

export const formatDocumentoInput = (value = '', tipoPessoa: TipoPessoa | null): string => {
  if (tipoPessoa === 'JURIDICA') {
    return formatAlphanumericCNPJ(value);
  }

  const digits = String(value || '').replace(/\D/g, '').slice(0, CPF_LENGTH);
  return applyCpfMask(digits);
};

export const normalizeDocumentoInput = (value = '', tipoPessoa: TipoPessoa | null): string => {
  if (tipoPessoa === 'JURIDICA') {
    return normalizeAlphanumericCNPJ(value);
  }

  return String(value || '').replace(/\D/g, '').slice(0, CPF_LENGTH);
};

export const validateDocumentoInput = (value = '', tipoPessoa: TipoPessoa | null): boolean => {
  if (tipoPessoa === 'JURIDICA') {
    return validateAlphanumericCNPJ(value);
  }

  if (tipoPessoa === 'FISICA') {
    return !!validateCpf(value);
  }

  return false;
};
